import { IconButton } from '@mui/material'
import { ComponentType, ReactNode } from 'react'

import { ArrowIcon } from 'src/assets/icons'
import { useStyles } from './styles'

interface IProps {
  icon: ComponentType<{ className: string }>
  label: string
  rightNode?: ReactNode
  handleClick?: () => void
}

export const SettingsDropdownMobile = ({ icon: Icon, label, rightNode, handleClick }: IProps) => {
  const classes = useStyles()

  return (
    <div className={classes.settingsItemWrapper}>
      <div className={classes.settingsLeftWrapper}>
        <div className={`${classes.settingsIconWrapper} ${classes.settingsIconWrapperLight}`}>
          <Icon className={classes.lightIcon} />
        </div>
        <h4 className={`${classes.settingsTitle} ${classes.settingsTitleDark}`}>{label}</h4>
      </div>
      <div>
        {rightNode ? (
          rightNode
        ) : (
          <IconButton onClick={handleClick}>
            <ArrowIcon className={`${classes.dropdownIcon} ${classes.greyIcon}`} />
          </IconButton>
        )}
      </div>
    </div>
  )
}
